export default __webpack_public_path__ + "static/media/header.923e69f9.svg";